import { LOGIN_LANDING } from "../../constants/paths"

export const isAllowedForAlertMessage = (route: string): boolean =>
	route !== LOGIN_LANDING
